import { Crown, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface PremiumModalProps {
  open: boolean;
  onClose: () => void;
  feature: string;
  description?: string;
}

export function PremiumModal({ open, onClose, feature, description }: PremiumModalProps) {
  const { t } = useTranslation();
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={onClose}>
      <div
        className="w-full max-w-sm max-h-full overflow-y-auto rounded-xl bg-surface-primary p-6 shadow-xl"
        onClick={e => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <Crown className="h-5 w-5 text-amber-500" />
            <h2 className="text-lg font-semibold text-text-primary">{t('expenses:recurring.empty.premiumFeature')}</h2>
          </div>
          <button onClick={onClose} className="rounded-md p-1 text-text-quaternary hover:text-text-secondary">
            <X className="h-5 w-5" />
          </button>
        </div>

        <p className="text-sm text-text-secondary">
          <span className="font-medium text-text-primary">{feature}</span> {t('web:premiumModal.isAvailableWithASharecostPremium')}
        </p>

        {description && (
          <p className="mt-2 text-sm text-text-tertiary">{description}</p>
        )}

        <div className="mt-6 rounded-lg bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 px-4 py-3">
          <p className="text-sm font-medium text-amber-800 dark:text-amber-300">
            {t('web:common.upgradeViaTheMobileApp')}
          </p>
          <p className="mt-0.5 text-xs text-amber-700 dark:text-amber-400">
            {t('web:premiumModal.openSharecostOnYourPhoneTo')}
          </p>
        </div>

        <button
          onClick={onClose}
          className="mt-4 w-full rounded-lg border border-border-secondary px-4 py-2 text-sm font-medium text-text-secondary hover:bg-surface-hover"
        >
          {t('common:button.close')}
        </button>
      </div>
    </div>
  );
}
